import { formatDate } from "./functions";
import renderFileList from "../components/renderFileList";
export const yhzh = ['公户', '微信'];
// export const webapi = 'http://localhost/api.php';
export const webapi = 'http://oa.guquanjianshe.com/api.php';
export const webimg = 'http://img.guquanjianshe.com/';
export const webqiniu = 'http://up-z0.qiniup.com';

export const tbcols = [
    {
        title: '序号',
        dataIndex: 'sn',
        key: 'sn',
        width: 58,
        fixed: 'left',
        render: (text, record, rowIndex) => {
            return rowIndex + 1;
        },
    },
    {
        title: '项目名称',
        dataIndex: 'xmmc',
        width: 240,
        key: 'xmmc',
        fixed: 'left', // 固定左侧
    },
    {
        title: '报名日期',
        dataIndex: 'startTime',
        width: 110,
        key: 'startTime',
        render: (_) => {
            return formatDate(_);
        }
    },
    {
        title: '开标时间',
        dataIndex: 'sh1time',
        width: 110,
        key: 'sh1time',
        style: 'color:red',
        render: (_) => {
            return formatDate(_);
        }
    },
    {
        title: '陪标/中标',
        dataIndex: 'sh1ps2',
        width: 100,
        key: 'sh1ps2',
        render: (_, rs) => {
            return <div style={{ 'background': 'yellow' }}>{rs.sh1ps2}</div>
        }
    },
    {
        title: '缴费金额',
        dataIndex: 'amount',
        width: 100,
        key: 'amount'
    },
    {
        title: '缴费日期',
        dataIndex: 'ptime',
        width: 120,
        key: 'ptime',
        render: (_, record) => {
            return record.ptime ? formatDate(record.ptime) : '';
        }
    },
    {
        title: '收款账号',
        dataIndex: 'zh',
        width: 120,
        key: 'zh'
    },
    {
        title: '客户名称',
        dataIndex: 'khname',
        width: 100,
        key: 'khname'
    },
    {
        title: '业绩归属',
        dataIndex: 'ywname',
        width: 120,
        key: 'ywname',
    },
    {
        title: '平台',
        dataIndex: 'pt',
        width: 100,
        key: 'pt'
    },
    {
        title: '备注',
        dataIndex: 'bs',
        width: 120,
        key: 'bs'
    },
    {
        title: '是否有效',
        dataIndex: 'iszb',
        width: 120,
        key: 'iszb',
        render: (_, record) => {
            if (record.iszb - 1 !== 0) {
                return <div style={{ color: 'red' }}>无效</div>
            }
        }
    },
    {
        title: '所用电脑编号',
        dataIndex: 'dnbh',
        width: 120,
        key: 'dnbh'
    },
    {
        title: '锁编号',
        dataIndex: 'sbh',
        width: 100,
        key: 'sbh'
    },
    {
        title: '进度',
        dataIndex: 'jd',
        width: 100,
        key: 'jd'
    },
    {
        title: '授权委托人',
        dataIndex: 'wtname',
        width: 120,
        key: 'wtname'
    },
    {
        title: '项目经理',
        dataIndex: 'xmjl',
        width: 120,
        key: 'xmjl'
    },

    {
        title: '其他资料',
        dataIndex: 'files',
        width: 120,
        key: 'files',
        render: (_, record) => {
            return (
                <div>
                    {renderFileList(record.files)}
                </div>
            );
        }
    }

]